module.exports = __webpack_public_path__ + "static/mastercard-logo-small-79e436626b3d42da86373bb0dbb7ef02.svg";